import { Component, OnInit } from '@angular/core';
import { Przystanek } from '../stops.component';
import { LinesService } from '../../lines/lines.service';
import { ActivatedRoute } from '@angular/router';
import { StopsService } from '../stops.service';

@Component({
  selector: 'app-details-stop',
  templateUrl: './details-stop.component.html',
  styleUrls: ['./details-stop.component.css']
})
export class DetailsStopComponent implements OnInit {
  index: number;
  przystanek: Przystanek;
  constructor(private _activeRoute: ActivatedRoute, private linesService: LinesService, private stopsService: StopsService) { }

  ngOnInit() {
    this.index = this._activeRoute.snapshot.params['id'];
    for (const przys of this.stopsService.przystanekAutobusowy) {
      if (przys.id == this.index) {
        this.przystanek = przys;
        break;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/stops/details-stop/details-stop.component.ts